
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import Color from '../../../../node_modules/color/index.js';
import { colors } from '../colors.js';

var card = {
  background: colors.white,
  shadow: colors.secondary.light,
  border: colors.secondary.light,
  hover: {
    background: Color(colors.primary.darker).alpha(0.9).string()
  },
  overlay: {
    background: Color(colors.primary.darker).alpha(0.5).string()
  }
};

export { card as default };
//# sourceMappingURL=card.js.map
